import { render, staticRenderFns } from "./UltimaFacturaComponent.vue?vue&type=template&id=7ff1886a&scoped=true"
import script from "./UltimaFacturaComponent.vue?vue&type=script&lang=js"
export * from "./UltimaFacturaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1886a",
  null
  
)

export default component.exports